import checkout from "./form";

const {
  formField: {},
} = checkout;

const initialValues = {};

export default initialValues;
